export default $wire => ({
    hasLocationModal: $wire.get('hasLocationModal'),
    projectUrl: $wire.entangle('projectUrl').live,
    activeTabs: $wire.get('activeTabs'),

    init() {
        let activeTab = document.location.hash;

        if (activeTab) {
            const cleanedTab = activeTab.replace('#', '');
            const availableTabs = JSON.parse(this.activeTabs);
            this.$nextTick(() => {
                this.scrollToTabContent(availableTabs[cleanedTab]);
            });
        }
    },
    changeTab(tab, tabName) {
        this.scrollToTabContent(tab);
        window.history.pushState(null, null, `${this.projectUrl}#${tabName}`);
    },
    scrollToTabContent(tab) {
        if (this.$refs[tab]) {
            this.$refs[tab].scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    },
});
